// The top left corner of a square on the board of this screen. The board
// turns for a person who plays Moon, so every layer of the board reads this.

import { type Point, squareOrigin } from '../motion/carry';
import { isBoardFlipped } from '../state/localSide';

export const boardOrigin = (square: number): Point => squareOrigin(square, isBoardFlipped());
